import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  width: 100%;
  height: 100%;
`

export const ContainerContent = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: 4px;
  padding: 1.5rem;

  display: grid;
  column-gap: 1.5rem;
  grid-auto-rows: min-content;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 1155px) {
    grid-template-columns: 1fr;
  }

  overflow-y: scroll;
  ${VerticalStyledScrollBar}
`
export const ContainerAlert = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  > span {
    color: ${props => props.theme.colors.colorb2b5ca};
    font-size: 1rem;
  }

  b {
    font-weight: 700;
  }
`
